import type { SubscribeRequest } from "@/modules/events/types/eventDetailsApi"
import type { UseMutationResult } from "@tanstack/react-query"

import { useMutation } from "@tanstack/react-query"

import { postSubscribe } from "@/modules/events/api/postSubscribe"

export const useSubscribe = (): UseMutationResult<void, Error, SubscribeRequest> =>
  useMutation<void, Error, SubscribeRequest>({ mutationFn: postSubscribe })
